import { createStore, combineReducers, applyMiddleware } from "redux";

import thunk from "redux-thunk";

import { composeWithDevTools } from "redux-devtools-extension";

// import {
//   userLoginReducer,
//   userProfileEditReducer,
//   userRegisterReducer
// } from './reducers/userReducer';
import {
  addCommentReducer,
  getAllProjectsReducer,
  nearbyProjectsReducer,
} from "./reducers/nearByProjectsReducers";
import {
  getAllUsersReducer,
  userDetailsReducer,
  userLoginReducer,
  userRegisterReducer,
  userUpdateReducer,
} from "./reducers/userReducers";
import {
  getAllProposalsApproverReducer,
  proposalCreateReducer,
  updateProposalReducer,
} from "./reducers/proposalReducers";

const reducer = combineReducers({
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userUpdateData: userUpdateReducer,
  nearbyProjectsData: nearbyProjectsReducer,
  getAllProjectsData: getAllProjectsReducer,
  addCommentData: addCommentReducer,
  createdProposalData: proposalCreateReducer,
  getAllUsersData: getAllUsersReducer,
  userDetailsData: userDetailsReducer,
  allProposalsApproverData: getAllProposalsApproverReducer,
  approvedProposalData: updateProposalReducer,
});

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const initialState = {
  userLogin: {
    userInfo: userInfoFromStorage,
  },
};

const middleware = [thunk];
const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
